var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useNoteSetupContext } from 'shared/features/note-setup';
import { appointmentMethod } from 'constants/ehrNoteEnums';
import { formatPostalAddress } from 'shared/utils';
import { useMe } from 'shared/hooks';
import { useNoteSchemaContext } from 'shared/features/note';
export var useDefaultClientLocation = function (enabled) {
    var _a, _b;
    var form = useNoteSchemaContext().form;
    var _c = useFormContext(), reset = _c.reset, getValues = _c.getValues;
    var noteSetupData = useNoteSetupContext().data;
    var me = useMe().data;
    var memberPostalAddress = (_b = (_a = noteSetupData === null || noteSetupData === void 0 ? void 0 : noteSetupData.appointment) === null || _a === void 0 ? void 0 : _a.member) === null || _b === void 0 ? void 0 : _b.postal_address;
    var formattedMemberAddress = formatPostalAddress(memberPostalAddress);
    var formattedProviderAddress = formatPostalAddress(me === null || me === void 0 ? void 0 : me.care_provider);
    useEffect(function () {
        if (enabled) {
            // Watch method and update address when it changes
            var methodWatch_1 = form.watch(function (value, _a) {
                var _b;
                var name = _a.name;
                if (name === 'sessionInfo.method') {
                    var method = (_b = value.sessionInfo) === null || _b === void 0 ? void 0 : _b.method;
                    if (method === appointmentMethod.telehealth) {
                        reset(__assign(__assign({}, getValues()), { sessionInfo: __assign(__assign({}, getValues().sessionInfo), { location: formattedMemberAddress }) }));
                    }
                    else if (method === appointmentMethod.inPerson) {
                        reset(__assign(__assign({}, getValues()), { sessionInfo: __assign(__assign({}, getValues().sessionInfo), { location: formattedProviderAddress }) }));
                    }
                }
            });
            return function () { return methodWatch_1.unsubscribe(); };
        }
    }, [formattedMemberAddress, formattedProviderAddress, form]);
};
